import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgActionCopyFill = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path fill="#2D2E2E" d="M18 6H2v16h16V6Z" />
    <path fill="#2D2E2E" d="M6 2v2h14v14h2V2H6Z" />
  </svg>
);
export default SvgActionCopyFill;
